var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2341 11.8287C15.0912 11.2287 15.6913 10.2858 15.6913 9.42863C15.6913 7.45717 14.2341 6 12.2626 6H6.94824V18.0002H12.9483C14.7484 18.0002 16.1198 16.543 16.1198 14.743C16.1198 13.4573 15.3484 12.343 14.2341 11.8287ZM9.43394 8.14263H12.0054C12.6911 8.14263 13.2911 8.74264 13.2911 9.42836C13.2911 10.1141 12.6911 10.7141 12.0054 10.7141H9.43394V8.14263ZM12.434 15.857H9.43394V13.2855H12.434C13.1197 13.2855 13.7197 13.8855 13.7197 14.5712C13.7197 15.2569 13.2054 15.857 12.434 15.857Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBold);
export default __webpack_public_path__ + "static/media/FormatBold.391f109547c359320d4e6844589d88f0.svg";
export { ForwardRef as ReactComponent };